import { render } from "./AccountsPage.vue?vue&type=template&id=6ebee654&scoped=true"
import script from "./AccountsPage.vue?vue&type=script&lang=js"
export * from "./AccountsPage.vue?vue&type=script&lang=js"

import "./AccountsPage.vue?vue&type=style&index=0&id=6ebee654&lang=css"
import "./AccountsPage.vue?vue&type=style&index=1&id=6ebee654&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebee654"]])

export default __exports__